import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, allow }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#EFE7D6]">
        <div className="w-8 h-8 border-2 border-[#1A362B] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (allow && !allow.includes(user.role)) {
    const target = user.role === "admin" ? "/admin" : user.role === "delivery" ? "/delivery" : "/shop";
    return <Navigate to={target} replace />;
  }
  return children;
}
